export const errors = {
  'Something went wrong': 'Quelque chose s\'est mal passé',
  'Page not found': 'Page non trouvée',
  'Go back home': 'Retour à l\'accueil',
};
